import React from "react";
import { fmtMoney, fmtPct, TYPE_STYLE, fmtDate } from "../lib/format";
import { MapPin, Flame } from "@phosphor-icons/react";
import PropertyImage from "./PropertyImage";

export default function LeadCard({ lead, onClick }) {
  const s = TYPE_STYLE[lead.property_type] || TYPE_STYLE.Residential;
  const isHot = lead.stage === "hot_deals";
  return (
    <button
      onClick={onClick}
      data-testid={`lead-card-${lead.id}`}
      className="deal-card w-full text-left rounded-sm block group overflow-hidden"
    >
      <PropertyImage address={lead.address} city={lead.city} state={lead.state} zip={lead.zip_code} height={110} />
      <div className="p-3.5">
      <div className="flex items-start justify-between gap-2 mb-2">
        <div className="min-w-0">
          <div className="text-sm font-semibold tracking-tight truncate">{lead.address}</div>
          <div className="text-[11px] text-zinc-500 mono truncate flex items-center gap-1">
            <MapPin size={11} /> {lead.city}, {lead.state} {lead.zip_code}
          </div>
        </div>
        <span
          className="mono text-[10px] uppercase tracking-[0.14em] px-1.5 py-0.5 rounded-sm border shrink-0"
          style={{ color: s.fg, borderColor: s.border, background: s.bg }}
        >
          {lead.property_type.slice(0, 3)}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-2 mt-3">
        <div>
          <div className="overline">Est. Value</div>
          <div className="mono text-sm text-zinc-100 mt-0.5">{fmtMoney(lead.estimated_value)}</div>
        </div>
        <div>
          <div className="overline">Equity</div>
          <div className="mono text-sm text-emerald-400 mt-0.5">{fmtPct(lead.equity_percentage)}</div>
        </div>
      </div>

      {lead.offer_amount ? (
        <div className="mt-3 flex items-center justify-between text-[11px] mono border-t border-zinc-800/70 pt-2">
          <span className="text-zinc-500">MAO</span>
          <span className="text-zinc-200">{fmtMoney(lead.offer_amount)}</span>
        </div>
      ) : null}
      {lead.projected_profit ? (
        <div className="mt-1 flex items-center justify-between text-[11px] mono">
          <span className="text-zinc-500">Proj. profit</span>
          <span className="text-emerald-400">{fmtMoney(lead.projected_profit)}</span>
        </div>
      ) : null}

      <div className="mt-2 flex items-center justify-between text-[10px] mono text-zinc-500">
        <span>{lead.last_contacted_at ? `Last: ${fmtDate(lead.last_contacted_at)}` : "Untouched"}</span>
        {lead.follow_up_count ? <span>FU · {lead.follow_up_count}</span> : null}
      </div>

      {isHot && (
        <div className="mt-2 flex items-center gap-1.5 text-emerald-400 text-[11px] mono">
          <Flame size={12} weight="fill" /> Seller responded YES
        </div>
      )}
      {lead.manual_skip_trace_pending && (
        <div className="mt-2 flex items-center gap-1.5 text-violet-300 text-[10px] mono uppercase tracking-[0.15em]" data-testid={`lead-manual-hold-${lead.id}`}>
          <span className="w-1.5 h-1.5 rounded-full bg-violet-400" /> Contact locked · Buy Contact to skip-trace
        </div>
      )}
      {lead.source === "zillow" && !lead.manual_skip_trace_pending && (
        <div className="mt-2 text-[10px] mono uppercase tracking-[0.15em] text-violet-300">Zillow{lead.days_on_market ? ` · ${lead.days_on_market}d on market` : ""}</div>
      )}
      </div>
    </button>
  );
}
